import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { WayAccountData } from './../_models/way/wayAccountData';
import { environment } from '../../../environments/environment';

@Injectable()
export class WayService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getWayAccountData(): Observable<WayAccountData> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/way/getWayAccountData')
      .pipe(map((response) => response));
  }

  storeWayCredentials(wayAccountData: WayAccountData) {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/way/storeWayCredentials', wayAccountData)
      .pipe(map((response) => response));
  }
}
